// extracted by mini-css-extract-plugin
export var loading_overlay = "LoadingOverlay-module--loading_overlay--FnWxw";
export var fade_out = "LoadingOverlay-module--fade_out--SMja0";
export var fadeOut = "LoadingOverlay-module--fadeOut--pf40N";
export var loader = "LoadingOverlay-module--loader--nwJy0";
export var loader_back = "LoadingOverlay-module--loader_back--sezn3";
export var loader_fill = "LoadingOverlay-module--loader_fill--XFgIn";